import { atelier } from './atelier';
import { premium } from './premium';
import { chantier } from './chantier';
import type { ThemeMetadata, ThemeName, ThemeMode } from './types';

export const themes: ThemeMetadata[] = [atelier, premium, chantier];

export const themesByName: Record<ThemeName, ThemeMetadata> = {
  atelier,
  premium,
  chantier,
};

export type { ThemeName, ThemeMode, ThemeMetadata, ThemePreview } from './types';

export const DEFAULT_THEME: ThemeName = 'chantier';
export const DEFAULT_MODE: ThemeMode = 'light';
